import React from 'react';
import AbstractSuspendedOverlay from './AbstractSuspendedOverlay';
import OverlayFrame from './OverlayFrame';
import { translate } from 'store/modules/base/i18n';
import { reloadNow } from 'store/modules/app/actions';
import { connect } from 'store/modules/base/redux';

/**
 * Implements a React Component for suspended overlay. Shown when a suspend is
 * detected.
 */
class SuspendedOverlay extends AbstractSuspendedOverlay {
  /**
   * Implements React's {@link Component#render()}.
   *
   * @inheritdoc
   * @returns {ReactElement}
   */
  render() {
    const { t } = this.props;

    return (
      <OverlayFrame>
        <div className="inlay">
          <span className="inlay__icon icon-microphone" />
          <span className="inlay__icon icon-camera" />
          <h3 className="inlay__title">{t('suspendedoverlay.title')}</h3>
          <button
            className="button-control button-control_overlay button-control_center'"
            onClick={() => this.props.dispatch(reloadNow())}>
            {this.props.t('suspendedoverlay.rejoinKeyTitle')}
          </button>
        </div>
      </OverlayFrame>
    );
  }
}

export default connect()(translate(SuspendedOverlay));
